/**
 * Wishlist badge updater — keeps [data-wishlist-count] in sync after YITH AJAX.
 * No ES module syntax — concatenated into one bundle by Gulp.
 */
function initWishlist() {
    if ( typeof jQuery === 'undefined' ) return;

    jQuery(document.body).on('added_to_wishlist removed_from_wishlist', function() {
        jQuery.get(
            typeof yith_wcwl_l10n !== 'undefined' ? yith_wcwl_l10n.ajax_url : '',
            { action: 'yith_wcwl_update_wishlist_count' }
        ).done(function(count) {
            var n = parseInt(count, 10) || 0;
            document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
                el.textContent = n;
                el.classList.toggle('has', n > 0);
                el.style.display = n > 0 ? '' : 'none';
            });
        });
    });
}
